// Local translations
export const T = {
  en_GB: {
    copy: "Copy",
    name: "Name",
    apiKeyCreated: "API Key Created",
    createApiKeyTitle: "Create API Key",
    apiKeyCreatedDescription: "Copy and save your API key securely. It will only be shown once.",
    createApiKeyDescription: "Create a new API key for external integrations.",
    nameRequired: "Name is required",
    somethingWentWrong: "Something went wrong",
    failedToCreateApiKey: "Failed to create API key",
    namePlaceholder: "e.g., Production Frontend, Mobile App",
    nameHint: "A descriptive name to identify this API key",
    createApiKey: "Create API Key",
    cancel: "Cancel",
    saveApiKeyWarningTitle: "Save this API key now!",
    saveApiKeyWarningDescription: "This is the only time you will see this key. Store it securely.",
    apiKeyLabel: "API Key",
    howToUse: "How to use:",
    howToUseDescription: "Include this key in the Authorization header of your API requests:",
    done: "Done",
    copyApiKeyTitle: "Copy API Key",
    copyApiKeyDescription: "Have you copied your API key? You won't be able to see it again!",
    yesCopied: "Yes, I've Copied It",
    notYet: "Not Yet",
  },
  nb_NO: {
    copy: "Kopier",
    name: "Navn",
    apiKeyCreated: "API-nøkkel opprettet",
    createApiKeyTitle: "Opprett API-nøkkel",
    apiKeyCreatedDescription: "Kopier og lagre API-nøkkelen din sikkert. Den vises bare én gang.",
    createApiKeyDescription: "Opprett en ny API-nøkkel for eksterne integrasjoner.",
    nameRequired: "Navn er påkrevd",
    somethingWentWrong: "Noe gikk galt",
    failedToCreateApiKey: "Kunne ikke opprette API-nøkkel",
    namePlaceholder: "f.eks. Produksjon Frontend, Mobilapp",
    nameHint: "Et beskrivende navn for å identifisere denne API-nøkkelen",
    createApiKey: "Opprett API-nøkkel",
    cancel: "Avbryt",
    saveApiKeyWarningTitle: "Lagre denne API-nøkkelen nå!",
    saveApiKeyWarningDescription:
      "Dette er den eneste gangen du vil se denne nøkkelen. Lagre den sikkert.",
    apiKeyLabel: "API-nøkkel",
    howToUse: "Slik bruker du den:",
    howToUseDescription:
      "Inkluder denne nøkkelen i Authorization-headeren i API-forespørslene dine:",
    done: "Ferdig",
    copyApiKeyTitle: "Kopier API-nøkkel",
    copyApiKeyDescription: "Har du kopiert API-nøkkelen din? Du vil ikke kunne se den igjen!",
    yesCopied: "Ja, jeg har kopiert den",
    notYet: "Ikke ennå",
  },
} as const;
